<template>
  <li :class="['link', {'active': isTagTabActive}]" class="link" >
    <div>
      <div class="menuIcon">
        <TagIcon color="#BFC2C4" />
      </div>
      <div :class="['menuText', { menuTextActive: isMenuOpen }]">Метки</div>
      <button class="tagButton" @click="openTagsModal">
        <ico name="icoMoreVert" color="#FFFFF9" />
      </button>
    </div>
  </li>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TagEditorModal from "./TagEditorModal.vue";
import { TagsEditorModalProperties } from "../../utils/modalsProperties";
import TagIcon from "./TagIcon.vue";
import { purchasesPath } from "@/router/purchases";

export default {
  name: "TagMenuButton",
  components: { TagIcon },
  props: {
    isMenuOpen: {
      type: Boolean,
      required: true,
    },
    isTagTabActive: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    ...mapActions("filterTabs", ["setCurrentTab"]),
    openTagsModal() {
      if (!this.authorities.includes("ROLE_SUBSCRIBED_USER")) {
        return false;
      }
      if (this.currentTab.filterType === "TAG") {
        const allTab = this.filterTabs.find((tab) => tab.filterType === "ALL");
                this.$router.push(`${purchasesPath}`);
        this.setCurrentTab(allTab);
      }
      this.$modal.show(TagEditorModal, {}, TagsEditorModalProperties);
    },
  },
  computed: {
    ...mapGetters("auth", ["email", "authorities"]),
    ...mapGetters("filterTabs", ["currentTab", "filterTabs"]),
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/variables.less";

.link {
  list-style-type: none;
  height: 64px;
  padding: 20px 10px 20px 20px !important;
  cursor: pointer;

  &:hover {
    background-color: #3c3e3a;
  }

  div {
    color: white;
    height: 24px;
    white-space: nowrap;
    display: flex;
    justify-content: flex-start;

    .menuText {
      font-weight: 500;
      transition: 0.3s ease opacity;
      opacity: 0;
      margin: 3px auto auto 16px;
      font-size: 16px;
      letter-spacing: 0.31px;
      color: #fffff9;
    }

    .menuTextActive {
      opacity: 1;
    }

    .menuIcon {
      min-width: 24px;
      min-height: 24px;
      width: 24px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      opacity: 1;
    }
  }

  &.active {
    background-color: @active-router-link-color;
  }

  .tagButton {
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.15s ease-in-out;
  }
  &:hover .tagButton {
    opacity: 1;
    pointer-events: auto;
  }
}
</style>
